import * as actionTypes from './actionTypes';
import Parse from '../../Parse';

export const getSettings = (settings) => {
    return {
        type: actionTypes.SETTINGS_FETCH,
        settings: settings
    };
};

export const settingFetch = () => {
    return dispatch => {
        Parse.Config.get().then((res) => {
            dispatch(getSettings(res));
        });
    };
};